import { render } from "./MultiVoucherConfig.vue?vue&type=template&id=56def51e&scoped=true"
import script from "./MultiVoucherConfig.vue?vue&type=script&lang=ts"
export * from "./MultiVoucherConfig.vue?vue&type=script&lang=ts"

import "./MultiVoucherConfig.vue?vue&type=style&index=0&id=56def51e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-56def51e"

export default script